import { render, staticRenderFns } from "./MultiTask.vue?vue&type=template&id=5e6bf245&scoped=true&"
import script from "./MultiTask.vue?vue&type=script&lang=js&"
export * from "./MultiTask.vue?vue&type=script&lang=js&"
import style0 from "./MultiTask.vue?vue&type=style&index=0&id=5e6bf245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6bf245",
  null
  
)

export default component.exports